export enum TechintelMappingOptionTypeEnum {
  CATEGORY = 'CATEGORY',
  PROVIDER = 'PROVIDER',
  PRODUCT = 'PRODUCT',
}
